import styled from 'styled-components';
import { GREY_500, GREY_800 } from '../../../constants';

export const Container = styled.div`
    padding: 0.75rem 0;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    gap: 1rem;
    height: 100%;
    min-height: 0;
`;

export const Header = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    width: 100%;
    padding: 0 1.5rem;
    box-sizing: border-box;
`;

export const HeaderContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    gap: 0.5rem;
`;

export const HeaderActions = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-shrink: 0;
`;

export const Title = styled.h3`
    font-size: 1.125rem;
    font-weight: 400;
    line-height: 1.5rem;
    letter-spacing: 0.0125rem;
    color: ${GREY_800};
`;

export const Description = styled.p`
    font-size: 0.8125rem;
    font-weight: 300;
    line-height: 1rem;
    color: ${GREY_500};
    margin: 0;
`;

export const ListWrap = styled.div`
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
`;
